import React from "react";
import { useUserContext } from "context/UserContext";
import ProductsBK from "layouts/BK/products";
import { canUseManagerRouteSet, normalizeRoleLevel } from "utils/roleUtils";

function Products() {
  const { roleLevel } = useUserContext() || {};
  if (canUseManagerRouteSet(normalizeRoleLevel(roleLevel))) {
    return <ProductsBK />;
  }
  return null;
}

export default Products;
